const SteelBike = [
    {
        "original": "https://crankybicycle.netlify.app/media/portfolio/versace/v1.jpg",
        "thumbnail": "https://crankybicycle.netlify.app/media/portfolio/versace/v1.jpg",
        "originalHeight": "500px"
    },
    {
        "original": "https://crankybicycle.netlify.app/media/portfolio/versace/v2.jpg",
        "thumbnail": "https://crankybicycle.netlify.app/media/portfolio/versace/v2.jpg",
        "originalHeight": "500px"
    },
    {
        "original": "https://crankybicycle.netlify.app/media/portfolio/versace/v3.jpg",
        "thumbnail": "https://crankybicycle.netlify.app/media/portfolio/versace/v3.jpg",
        "originalHeight": "500px"
    },
    {
        "original": "https://crankybicycle.netlify.app/media/portfolio/versace/v4.jpg",
        "thumbnail": "https://crankybicycle.netlify.app/media/portfolio/versace/v4.jpg",
        "originalHeight": "500px"
    },
    {
        "original": "https://crankybicycle.netlify.app/media/portfolio/versace/v5.jpg",
        "thumbnail": "https://crankybicycle.netlify.app/media/portfolio/versace/v5.jpg",
        "originalHeight": "500px"
    },
    {
        "original": "https://crankybicycle.netlify.app/media/portfolio/versace/v6.jpg",
        "thumbnail": "https://crankybicycle.netlify.app/media/portfolio/versace/v6.jpg",
        "originalHeight": "500px"
    },
    {
        "original": "https://crankybicycle.netlify.app/media/portfolio/versace/v7.jpg",
        "thumbnail": "https://crankybicycle.netlify.app/media/portfolio/versace/v7.jpg",
        "originalHeight": "500px"
    }
]

const Gazelle = [
    {
        "original": "https://crankybicycle.netlify.app/media/portfolio/gezele/g1.jpg",
        "thumbnail": "https://crankybicycle.netlify.app/media/portfolio/gezele/g1.jpg",
        "originalHeight": "500px"
    },
    {
        "original": "https://crankybicycle.netlify.app/media/portfolio/gezele/g2.jpg",
        "thumbnail": "https://crankybicycle.netlify.app/media/portfolio/gezele/g2.jpg",
        "originalHeight": "500px"
    },
    {
        "original": "https://crankybicycle.netlify.app/media/portfolio/gezele/g3.jpg",
        "thumbnail": "https://crankybicycle.netlify.app/media/portfolio/gezele/g3.jpg",
        "originalHeight": "500px"
    },
    {
        "original": "https://crankybicycle.netlify.app/media/portfolio/gezele/g4.jpg",
        "thumbnail": "https://crankybicycle.netlify.app/media/portfolio/gezele/g4.jpg",
        "originalHeight": "500px"
    },
    {
        "original": "https://crankybicycle.netlify.app/media/portfolio/gezele/g5.jpg",
        "thumbnail": "https://crankybicycle.netlify.app/media/portfolio/gezele/g5.jpg",
        "originalHeight": "500px"
    },
    {
        "original": "https://crankybicycle.netlify.app/media/portfolio/gezele/g6.jpg",
        "thumbnail": "https://crankybicycle.netlify.app/media/portfolio/gezele/g6.jpg",
        "originalHeight": "500px"
    },
    {
        "original": "https://crankybicycle.netlify.app/media/portfolio/gezele/g7.jpg",
        "thumbnail": "https://crankybicycle.netlify.app/media/portfolio/gezele/g7.jpg",
        "originalHeight": "500px"
    },
    {
        "original": "https://crankybicycle.netlify.app/media/portfolio/gezele/g8.jpg",
        "thumbnail": "https://crankybicycle.netlify.app/media/portfolio/gezele/g8.jpg",
        "originalHeight": "500px"
    },
    {
        "original": "https://crankybicycle.netlify.app/media/portfolio/gezele/g9.jpg",
        "thumbnail": "https://crankybicycle.netlify.app/media/portfolio/gezele/g9.jpg",
        "originalHeight": "500px"
    },
    {
        "original": "https://crankybicycle.netlify.app/media/portfolio/gezele/g10.jpg",
        "thumbnail": "https://crankybicycle.netlify.app/media/portfolio/gezele/g10.jpg",
        "originalHeight": "500px"
    },
]
const Guci = [
    {
        "original": "https://crankybicycle.netlify.app/media/portfolio/guci/gu1.jpg",
        "thumbnail": "https://crankybicycle.netlify.app/media/portfolio/guci/gu1.jpg",
        "originalHeight": "500px"
    },
    {
        "original": "https://crankybicycle.netlify.app/media/portfolio/guci/gu2.jpg",
        "thumbnail": "https://crankybicycle.netlify.app/media/portfolio/guci/gu2.jpg",
        "originalHeight": "500px"
    },
    {
        "original": "https://crankybicycle.netlify.app/media/portfolio/guci/gu3.jpg",
        "thumbnail": "https://crankybicycle.netlify.app/media/portfolio/guci/gu3.jpg",
        "originalHeight": "500px"
    },
    {
        "original": "https://crankybicycle.netlify.app/media/portfolio/guci/gu4.jpg",
        "thumbnail": "https://crankybicycle.netlify.app/media/portfolio/guci/gu4.jpg",
        "originalHeight": "500px"
    },
]
const Ural = [
    {
        "original": "https://crankybicycle.netlify.app/media/portfolio/jumis/j1.jpg",
        "thumbnail": "https://crankybicycle.netlify.app/media/portfolio/jumis/j1.jpg",
        "originalHeight": "500px"
    },
    {
        "original": "https://crankybicycle.netlify.app/media/portfolio/jumis/j2.jpg",
        "thumbnail": "https://crankybicycle.netlify.app/media/portfolio/jumis/j2.jpg",
        "originalHeight": "500px"
    },
    {
        "original": "https://crankybicycle.netlify.app/media/portfolio/jumis/j3.jpg",
        "thumbnail": "https://crankybicycle.netlify.app/media/portfolio/jumis/j3.jpg",
        "originalHeight": "500px"
    },
    {
        "original": "https://crankybicycle.netlify.app/media/portfolio/jumis/j4.jpg",
        "thumbnail": "https://crankybicycle.netlify.app/media/portfolio/jumis/j4.jpg",
        "originalHeight": "500px"
    },
    {
        "original": "https://crankybicycle.netlify.app/media/portfolio/jumis/j5.jpg",
        "thumbnail": "https://crankybicycle.netlify.app/media/portfolio/jumis/j5.jpg",
        "originalHeight": "500px"
    },
    {
        "original": "https://crankybicycle.netlify.app/media/portfolio/jumis/j6.jpg",
        "thumbnail": "https://crankybicycle.netlify.app/media/portfolio/jumis/j6.jpg",
        "originalHeight": "500px"
    },
    {
        "original": "https://crankybicycle.netlify.app/media/portfolio/jumis/j7.jpg",
        "thumbnail": "https://crankybicycle.netlify.app/media/portfolio/jumis/j7.jpg",
        "originalHeight": "500px"
    },
]
const Zil = [
    {
        "original": "https://crankybicycle.netlify.app/media/portfolio/black_panthera/bp1.jpg",
        "thumbnail": "https://crankybicycle.netlify.app/media/portfolio/black_panthera/bp1.jpg",
        "originalHeight": "500px"
    },
    {
        "original": "https://crankybicycle.netlify.app/media/portfolio/black_panthera/bp2.jpg",
        "thumbnail": "https://crankybicycle.netlify.app/media/portfolio/black_panthera/bp2.jpg",
        "originalHeight": "500px"
    },
    {
        "original": "https://crankybicycle.netlify.app/media/portfolio/black_panthera/bp3.jpg",
        "thumbnail": "https://crankybicycle.netlify.app/media/portfolio/black_panthera/bp3.jpg",
        "originalHeight": "500px"
    },
    {
        "original": "https://crankybicycle.netlify.app/media/portfolio/black_panthera/bp4.jpg",
        "thumbnail": "https://crankybicycle.netlify.app/media/portfolio/black_panthera/bp4.jpg",
        "originalHeight": "500px"
    },
]

export { SteelBike, Gazelle, Guci, Ural, Zil };